export default __webpack_public_path__ + "static/media/Sofia.2de9604b.ttf";